import * as App from "@timesheets/routes-app";

import { NavigationGuardNext, Route, RouteConfig } from "vue-router";

import { IApi } from "@timesheets/webapp-support";
import Login from "AccountPages/components/Login/Index.vue";
import NotFound from "Components/NotFound/NotFound.vue";
import { PageTypes } from "./PageTypes";
import { logout } from "@/utils";

export function commonRoutes(api: IApi, PageType: PageTypes): RouteConfig[] {
  const redirectRouteName = PageType === PageTypes.AccountPages ? "DefaultLogin" : "Home";

  return [
    {
      path: "/index.html",
      name: "Index",
      redirect: {
        name: redirectRouteName,
      },
    },
    {
      path: App.Login.Root,
      name: "DefaultLogin",
      component: Login,
    },
    {
      path: App.Login.Local,
      name: "LocalLogin",
      redirect: App.Login.Root,
    },
    {
      path: App.Logout.Local,
      name: "LocalLogout",
      redirect: App.Logout.Root,
    },
    {
      path: App.Logout.Root,
      name: "DefaultLogout",
      async beforeEnter(_to: Route, _from: Route, next: NavigationGuardNext) {
        await logout(api, undefined, false);
        next(App.Login.Root);
      },
    },
    {
      path: App.Profiles.Me,
      name: "Me",
      redirect: {
        name: redirectRouteName,
      },
    },
    {
      path: App.Profiles.Username,
      name: "UserName",
      redirect: {
        name: redirectRouteName,
      },
    },
    {
      path: App.Profiles.ProfileId,
      name: "ProfileId",
      redirect: {
        name: redirectRouteName,
      },
    },
    {
      path: "*",
      name: "NotFound",
      component: NotFound,
    },
  ];
}
